/**
 * @file Strategies.jsx
 * @description Main application interface with role-specific features
 * 
 * @section Responsibilities
 * - Manage role-based views
 * - Handle data aggregation
 * - Control real-time updates
 * - Manage user preferences
 * 
 * @section Dependencies
 * - Role Management: Access control
 * - Data Services: Information handling
 * - State Management: Global state
 * 
 * @section Integration Points
 * - Data API: Information retrieval
 * - Role System: Access control
 * - Notification System: Real-time updates
 * 
 * @section State Management
 * - dashboardData: Aggregated information
 * - loadingState: Data fetching
 * - errorState: Error handling
 * 
 * @section Events
 * - onDataUpdate: Data changes
 * - onError: Error handling
 * - onPreferenceChange: Settings updates
 * 
 * @section Props
 * @prop {String} userRole - Current user role
 * @prop {Object} permissions - User permissions
 */

import React, { useState } from 'react'
import DgButton from '../../../../components/DgButton';
import Widget from '../Widget';

function Strategies({ width }) {
    const [data, setData] = useState({
        strategy: "Bull"
    });

    return (
        <Widget name={"strategies"} width={width}>
            <div className="heading">
                <h1 className="title">Strategies</h1>
                <div className="score">
                    <div className="circle">
                        <span className='number'>325</span>
                        <span className='text'>Your Score</span>
                    </div>
                </div>
            </div>
            <div className="strategies-container">
                <div className={`strategy ${data.strategy == 'Hedgehog' ? 'recommended' : ''}`}>
                    <div className="strategy-content">
                        <div>
                            <img src="/assets/profiles/hedgehog.svg" alt="" />
                            <p className="strategy-title">Hedgehog</p>
                            <p className="strategy-description">Focuses on minimizing risks and maximizing long-term profits through diversification of the investment portfolio, in order to minimize the negative effects of market fluctuations.</p>

                        </div>
                        <div>
                            <div className="strategy-checklist">
                                <div className="check">
                                    <img src="/assets/check.png" alt="" className="check-img" />
                                    <span className='check-text'>Options</span>
                                </div>
                                <div className="check">
                                    <img src="/assets/check.png" alt="" className="check-img" />
                                    <span className='check-text'>Bonds</span>
                                </div>
                                <div className="check">
                                    <img src="/assets/check.png" alt="" className="check-img" />
                                    <span className='check-text'>ETFs</span>
                                </div>
                            </div>
                            <div className="button-container">
                                <DgButton category={"primary"} size={"medium"} text={"Choose"} action={() => { }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`strategy ${data.strategy == 'Bull' ? 'recommended' : ''}`}>
                    <div className="strategy-content">
                        <div>
                            <img src="/assets/profiles/bull-active.svg" alt="" />
                            <p className="strategy-title">Bull</p>
                            <p className="strategy-description">Used by investors who expect prices to go up in the future, in order to profit by selling at a higher price than they bought.</p>

                        </div>
                        <div>
                            <div className="strategy-checklist">
                                <div className="check">
                                    <img src="/assets/check.png" alt="" className="check-img" />
                                    <span className='check-text'>Options</span>
                                </div>
                                <div className="check">
                                    <img src="/assets/check.png" alt="" className="check-img" />
                                    <span className='check-text'>Bonds</span>
                                </div>
                                <div className="check">
                                    <img src="/assets/check.png" alt="" className="check-img" />
                                    <span className='check-text'>ETFs</span>
                                </div>
                            </div>
                            <div className="button-container">
                                <div className="button-gradient-wrapper">
                                    <DgButton category={"primary"} size={"medium"} text={"Selected"} action={() => { }} />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className={`strategy ${data.strategy == 'Bear' ? 'recommended' : ''}`}>
                    <div className="strategy-content">
                        <div>
                            <img src="/assets/profiles/bear.svg" alt="" />
                            <p className="strategy-title">Bear</p>
                            <p className="strategy-description">Used by investors who expect prices to go down in the future, in order to profit by selling at a higher price than they bought.</p>
                        </div>
                        <div>
                            <div className="strategy-checklist">
                                <div className="check">
                                    <img src="/assets/check.png" alt="" className="check-img" />
                                    <span className='check-text'>Options</span>
                                </div>
                                <div className="check">
                                    <img src="/assets/check.png" alt="" className="check-img" />
                                    <span className='check-text'>Bonds</span>
                                </div>
                                <div className="check">
                                    <img src="/assets/check.png" alt="" className="check-img" />
                                    <span className='check-text'>ETFs</span>
                                </div>
                            </div>
                            <div className="button-container">
                                <DgButton category={"primary"} size={"medium"} text={"Choose"} action={() => { }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Widget>
    )
}

export default Strategies